import { saveAs } from "file-saver";

class Controller {
  constructor(Events, Sections, InvoiceItemType) {
    "ngInject";

    this.Events = Events;
    this.sections = Sections.settingsSections;
    this.InvoiceItemType = InvoiceItemType;

    this.successNotificationEvent = this.Events.eventsType.onShowSuccessNotification;
    this.errorNotificationEvent = this.Events.eventsType.onShowErrorNotification;
  }

  $onInit() {
    this.getAllFileTypes();
  }

  getAllFileTypes() {
    this.InvoiceItemType.getTransactionFileTypes().$promise.then(
      (response) => {
        this.transactionFileTypes = response;
      },
      (response) => this.Events.emit(this.errorNotificationEvent, response.data)
    );
  }

  upload() {
    this.isUploading = true;
    const data = {
      file: this.file,
      city: this.city._id,
      type: this.invoiceItemType.type,
    };

    this.InvoiceItemType.uploadTransactionFile(data)
      .$promise.then(
        () => {
          this.Events.emit(this.successNotificationEvent, {
            message: "Your file has been uploaded successfully",
          });

          delete this.file;
          delete this.invoiceItemType;
          delete this.city;
          this.bulkInvoiceItemTypesUploadForm.$setUntouched();
        },
        (response) =>
          this.Events.emit(this.errorNotificationEvent, response.data)
      )
      .finally(() => {
        this.isUploading = false;
      });
  }

  downloadCSV() {
    const newRowRegex = "\r\n";
    const columns =
      this.invoiceItemType.fields.map(({ name }) => name).join(",") +
      newRowRegex;
    const csvFile = new File([columns], `${this.invoiceItemType.name}.csv`);
    saveAs(csvFile);
  }

  clear() {
    delete this.file;
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/bulkInvoiceItemTypesUpload/bulkInvoiceItemTypesUpload.controller.js